module.exports = __webpack_public_path__ + "media/images/ui-bg_flat_0_888888_40x100-06f99699a1351ae03a43810981e445d2.png";